<mat-accordion
  class="fixed z-[100] bottom-0 left-0 w-full document-upload-accordion"
  [class.hidden]="hidden && !panelOpenState">
  <mat-expansion-panel
    #matAccordion
    hideToggle
    class="flex flex-wrap"
    (opened)="panelOpenState = true"
    (closed)="panelOpenState = false">
    <mat-expansion-panel-header class="flex py-7 cursor-default grow">
      <mat-panel-description
        class="flex xs:justify-center px-36 sm:px-10 xs:px-4 m-0"
        [ngClass]="panelOpenState ? 'justify-end' : 'justify-between'">
        <div class="max-w-4xl xs:hidden" *ngIf="!panelOpenState">
          <div class="font-bold text-lg">
            {{ translations[0] | translate }}
          </div>
          <div class="text-sm">
            {{ translations[1] | translate }}
          </div>
        </div>
        <div>
          <button
            *ngIf="!panelOpenState"
            mat-flat-button
            color="primary"
            class="rounded-md">
            {{ translations[2] | translate }}
          </button>
          <button
            *ngIf="panelOpenState"
            mat-icon-button
            class="xs:hidden block">
            <i class="fa-regular fa-xmark"></i>
          </button>
          <i
            *ngIf="panelOpenState"
            class="fa-solid fa-dash fa-2xl xs:block hidden"
            style="color: #f0f0f0"></i>
        </div>
      </mat-panel-description>
    </mat-expansion-panel-header>

    <ng-content select="[uploader]" class="grow"></ng-content>
  </mat-expansion-panel>
</mat-accordion>
